import React, { createContext, useContext, useState } from "react";

interface IDefaultFilterContextProps {
  defaultFilters: any;
  setDefaultFilters: React.Dispatch<React.SetStateAction<string[]>>;
}

const FilterContext = createContext<IDefaultFilterContextProps | undefined>(
  undefined,
);

const DefaultFiltersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [defaultFilters, setDefaultFilters] = useState<any>({});

  React.useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      try {
        console.debug("DefaultFilters updated:", defaultFilters);
        console.debug("DefaultFilters.regulator:", defaultFilters?.regulator);
      } catch (_) {}
    }
  }, [defaultFilters]);

  return (
    <FilterContext.Provider value={{ defaultFilters, setDefaultFilters }}>
      {children}
    </FilterContext.Provider>
  );
};

const useDefaultFiltersContext = (): IDefaultFilterContextProps => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error(
      "useDefaultFiltersContext must be used within a DefaultFiltersProvider",
    );
  }
  return context;
};

export { DefaultFiltersProvider, useDefaultFiltersContext };
